<template>

    <!-- Main Sidebar -->
    <a-layout-sider collapsible class="sider-primary" breakpoint="lg" collapsed-width="0" width="250px"
        :collapsed="sidebarCollapsed" @collapse="$emit('toggleSidebar', ! sidebarCollapsed)" :trigger="null"
        :class="['ant-layout-sider-' + sidebarColor, 'ant-layout-sider-' + sidebarTheme]" theme="dark"
        :style="{ backgroundColor: 'transparent', }">
        <div class="brand"><img src="images/logo-ct-black.pn" alt=""> <span> آسان تهاتر ایرانیان </span>
        </div>
        <hr>

        <!-- Sidebar Navigation Menu -->
        <a-menu theme="light" mode="inline">
            <a-menu-item>
                <router-link to="/dashboard">
                        <a-icon type="line-chart" :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />
                    <span class="label">داشبورد</span>
                </router-link>

            </a-menu-item>

            <a-menu-item class="menu-item-header" v-show="$root.hasPermission('/users/list/')">
                کاربران
            </a-menu-item>

            <a-menu-item v-show="$root.hasPermission('/users/list/')">

                <router-link to="/users/list">

                       <a-icon type="team" :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />
                    <span class="label">کاربران</span>
                </router-link>
            </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/roles/list/')">

                <router-link to="/roles/list">

                    <a-icon type="usergroup-add" :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />
                    <span class="label">سطوح دسترسی</span>
                </router-link>
            </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/requests/cancellation/')">

                <router-link to="/requests/cancellation">

                    <a-icon type="usergroup-delete" :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }"  />
                    <span class="label"> درخواست های لغو عضویت</span>
                </router-link>
            </a-menu-item>



            <a-menu-item class="menu-item-header" v-show="$root.hasPermission('/products/list/')">
                مدیریت آگهی ها
            </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/products/list/')">

                <router-link to="/products/list">
<a-icon type="shopping"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }"  />
                    <span class="label"> آگهی ها </span>
                </router-link>
            </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/orders/list/')">

                <router-link to="/orders/list">
<a-icon type="shop"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />
                    <span class="label"> خرید و فروش ها </span>
                </router-link>
            </a-menu-item>
             <a-menu-item v-show="$root.hasPermission('/orders/wallet/')">

                <router-link to="/orders/wallet">

                   <a-icon type="wallet"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />

                    <span class="label"> شارژ کیف پول </span>
                </router-link>
            </a-menu-item>
             <a-menu-item v-show="$root.hasPermission('/orders/return/')">

                <router-link to="/orders/return">
                   <a-icon type="file-exclamation"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />

                    <span class="label"> درخواست های مرجوعی </span>
                </router-link>
            </a-menu-item>

            <a-menu-item class="menu-item-header" v-show="$root.hasPermission('/setting/main/')">
                تنظیمات
            </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/setting/main/')">
                <router-link to="/setting/main">

                   <a-icon type="global"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />
                    <span class="label">تنظیمات کلی </span>
                </router-link>
            </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/categories/list/')">
                <router-link to="/categories/list">

                                       <a-icon type="block"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />

                    <span class="label"> دسته بندی ها </span>
                </router-link>
            </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/specifications/list/')">
                <router-link to="/specifications/list">

                                      <a-icon type="bars"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />

                    <span class="label">مشخصات </span>
                </router-link>
            </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/units/list/')">
                <router-link to="/units/list">
                   <a-icon type="number"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />
                    <span class="label"> پروداکت یونیت </span>
                </router-link>
            </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/banners/list/')">
                <router-link to="/banners/list">

                                     <a-icon type="picture"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />

                    <span class="label">بنر ها </span>
                </router-link>
            </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/banners/setting/')">
                <router-link to="/banners/setting">

                   <a-icon type="audit" />
                    <span class="label"> تنظیمات بنرها</span>
                </router-link>
            </a-menu-item>


            <a-menu-item class="menu-item-header" v-show="$root.hasPermission('/seminars/list/')">
                سمینار ها
            </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/seminars/list/')">
                <router-link to="/seminars/list">

                                     <a-icon type="team"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />
                    <span class="label">  سمینار ها </span>
                </router-link>
            </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/seminars/reports/')">
                <router-link to="/seminars/reports">

                                                       <a-icon type="solution"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />

                    <span class="label">گزارشات سمینار </span>
                </router-link>
            </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/seminars/callcenter/')">
                <router-link to="/seminars/callcenter">

                                                        <a-icon type="phone"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />

                    <span class="label"> کال سنتر </span>
                </router-link>
            </a-menu-item>
            <a-menu-item class="menu-item-header" v-show="$root.hasPermission('/financials/list/')">
                مدیریت مالی
            </a-menu-item>

            <a-menu-item v-show="$root.hasPermission('/financials/list/')">

                <router-link to="/financials/list">

                 <a-icon type="red-envelope"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />

                    <span class="label"> کاربران</span>
                </router-link>
            </a-menu-item>

            <a-menu-item v-show="$root.hasPermission('/financials/transactions/')">

                <router-link to="/financials/transactions">

                                     <a-icon type="database"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />

                    <span class="label">  تراکنش ها</span>
                </router-link>
            </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/financials/withdraw/')">

                <router-link to="/financials/withdraw">

                                   <a-icon type="account-book"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />

                    <span class="label"> درخواست های برداشت</span>
                </router-link>
            </a-menu-item>

            <a-menu-item v-show="$root.hasPermission('/financials/report/')">

                <router-link to="/financials/report">

                                   <a-icon type="stock"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />

                    <span class="label">گزارشات مالی </span>
                </router-link>
            </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/financials/excelReports/')">

<router-link to="/financials/excelReports">

                   <a-icon type="stock"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />

    <span class="label">گزارشات اکسل مالی </span>
</router-link>
</a-menu-item>
          <a-menu-item v-show="$root.hasPermission('/financials/revenue/')">

            <router-link to="/financials/revenue">

              <a-icon type="stock"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />

              <span class="label">گزارشات کارمزدها </span>
            </router-link>
          </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/financials/providersReport/')">

                <router-link to="/financials/providersReport">

                    <a-icon type="stock" :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }"/>

                    <span class="label">گزارش خدمات دهندگان </span>
                </router-link>
            </a-menu-item>

            <a-menu-item class="menu-item-header" v-show="$root.hasPermission('/requests/messages/')">
                پلن های تبلیغاتی
            </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/requests/messages/')">

                <router-link to="/requests/messages">

                                   <a-icon type="red-envelope"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />

                    <span class="label">پیامک ها </span>
                </router-link>
            </a-menu-item>

            <a-menu-item v-show="$root.hasPermission('/requests/banners/')">

                <router-link to="/requests/banners">
                                   <a-icon type="border"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />

                    <span class="label">بنر ها </span>
                </router-link>
            </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/requests/offers/')">

                <router-link to="/requests/offers">

                                                       <a-icon type="tags"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />

                    <span class="label">پیشنهاد شگفت انگیز </span>
                </router-link>
            </a-menu-item>



            <a-menu-item class="menu-item-header" v-show="$root.hasPermission('/send/sms/')">
                ارسال همگانی
            </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/send/sms/')">

                <router-link to="/send/sms">

                                                       <a-icon type="message"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />

                    <span class="label">ارسال پیامک</span>
                </router-link>
            </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/send/notification/')">

                <router-link to="/send/notification">

                                                       <a-icon type="notification"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />

                    <span class="label">ارسال نوتیفیکیشن</span>
                </router-link>
            </a-menu-item>

            <a-menu-item class="menu-item-header" v-show="$root.hasPermission('/tickets/list/')">
                لیست تیکت
            </a-menu-item>
            <a-menu-item v-show="$root.hasPermission('/tickets/list/')">

                <router-link to="/tickets/list">

                                                       <a-icon type="customer-service"  :style="{ fontSize: '18px', color: '#08c' ,paddingLeft: '10px' }" />

                    <span class="label">  تیکت ها</span>
                </router-link>
            </a-menu-item>
        </a-menu>
        <!-- / Sidebar Navigation Menu -->



    </a-layout-sider>
    <!-- / Main Sidebar -->

</template>

<script>
    export default ({
        props: {
            // Sidebar collapsed status.
            sidebarCollapsed: {
                type: Boolean,
                default: false,
            },

            // Main sidebar color.
            sidebarColor: {
                type: String,
                default: "primary",
            },

            // Main sidebar theme : light, white, dark.
            sidebarTheme: {
                type: String,
                default: "light",
            },
        },
        data() {
            return {
                // sidebarCollapsedModel: this.sidebarCollapsed,
            }
        },
    })
</script>
